import cn from 'classnames';

type AvatarProps = {
	src?: string;
	alt?: string;
	size?: 'small' | 'medium' | 'large' | 'xl' | 'm' | 'xxl';
	children?: React.ReactNode;
	letter?: string;
}

const Avatar = ({src, alt = 'Avatar', size = 'small', children, letter}: AvatarProps) => {
	let iconSize = '30';
	switch(size) {
		case 'small':
			iconSize = '30';
			break;
		case 'm': 
			iconSize = '40';
			break;
		case 'medium':
			iconSize = '45';
			break;
		case 'large':
			iconSize = '50';
			break;
		case 'xl':
			iconSize = '60';
			break;
		case 'xxl':
			iconSize = '80';
			break;
		default:
			iconSize = '30';
			break;
	}

	const generateAvatarImage = () => {
		if (children) {
			return children;
		}
		if(letter) {
			return <div className='avatar-letter'>{letter}</div>;
		}
		if(src) {
			return <img src={src} alt={alt} />;
		}
		return <svg width={iconSize} height={iconSize} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15 0C11.0218 0 7.2062 1.57963 4.39342 4.3917C1.58024 7.20356 0 11.0173 0 14.9941C0 18.971 1.58024 22.7849 4.39342 25.5966C7.20637 28.4086 11.0216 29.9883 15 29.9883C18.9784 29.9883 22.7938 28.4086 25.6066 25.5966C28.4198 22.7847 30 18.971 30 14.9941C29.9954 11.0188 28.4136 7.2079 25.6015 4.39678C22.7895 1.58566 18.9767 0.00462225 15 0Z" fill="#C3C3C3"/>
			<path fillRule="evenodd" clipRule="evenodd" d="M24.7281 26.367C24.8018 25.6865 24.6857 24.9675 24.4814 24.0994C24.1779 22.8559 22.9562 22.1623 21.651 21.5464C21.3635 21.4107 21.0693 21.2783 20.7758 21.1462C19.7898 20.7024 18.8113 20.262 18.1179 19.7111L18.0365 17.3938C18.925 16.544 19.601 15.6709 19.9201 14.6563C20.9686 13.8727 21.0382 11.5094 20.0321 10.719C20.1671 9.37695 20.2163 7.62811 19.9711 6.84336C19.366 4.95252 17.1144 3.89872 14.9415 3.90074L14.9419 3.90087C12.8485 3.83967 10.7489 4.93327 10.014 6.95622C9.79903 8.07141 9.67664 9.29187 9.84082 10.5242C9.0061 10.7422 8.95112 14.2752 9.98341 14.5229C10.349 15.5161 10.7423 16.4348 11.3782 17.2298L11.2459 19.7828C10.6475 20.2238 9.8307 20.6309 9.00771 21.0411C8.71973 21.1847 8.431 21.3286 8.15061 21.4745C6.22518 22.4401 4.82354 23.9179 5.37811 26.3186C8.1737 28.2763 11.5144 29.3567 14.9691 29.3809C15.2001 29.3799 15.4296 29.3768 15.6573 29.3717C18.9227 29.2618 22.0689 28.2095 24.7281 26.367Z" fill="white"/>
			<path fillRule="evenodd" clipRule="evenodd" d="M14.9348 29.9806L14.9346 30C14.9346 30 13.5485 30 11.7057 29.6488C11.3375 29.5786 11.032 29.4806 10.6194 29.3482C10.4296 29.2873 10.2171 29.2191 9.96539 29.143C9.71547 29.0674 9.5174 28.9745 9.22634 28.838C9.08483 28.7716 8.92133 28.6949 8.71921 28.6049C8.10138 28.3297 7.48586 28.0038 6.7495 27.5174C5.97785 27.0077 5.35229 26.4751 5.35229 26.4751C5.35229 26.4751 5.26052 25.9309 5.23346 25.3805C5.21152 24.9342 5.264 24.7133 5.36326 24.2954C5.36543 24.2862 5.36762 24.277 5.36984 24.2677C5.38363 24.2096 5.44774 24.0636 5.50378 23.9361C5.53709 23.8602 5.56755 23.7909 5.58289 23.7504C5.72534 23.444 6.20236 22.7351 6.88881 22.2437C7.6929 21.6681 8.0652 21.4968 8.0652 21.4968C9.029 21.062 10.0419 20.5664 11.2654 19.7275C11.2654 19.7275 11.206 20.626 11.6558 21.4294C12.1055 22.2329 12.8264 22.8494 13.6889 23.168C14.1134 23.3248 14.433 23.3946 14.6481 23.4249C14.8589 23.4028 15.21 23.3381 15.7021 23.1563C16.5647 22.8376 17.2855 22.2212 17.7353 21.4177C18.185 20.6143 18.1257 19.7158 18.1257 19.7158C19.1806 20.4392 20.1068 20.8498 20.9598 21.228C21.0961 21.2884 21.2305 21.3479 21.3633 21.4078C21.3633 21.4078 22.5227 21.9283 23.3268 22.5039C24.0132 22.9953 24.2403 23.4695 24.3828 23.7758C24.4239 23.8846 24.458 23.9845 24.48 24.0772C24.5835 24.5132 24.6307 24.7892 24.7044 25.2398C24.7893 25.759 24.7246 26.4335 24.7246 26.4335C24.7246 26.4335 22.6667 28.1478 20.4575 28.974C18.6643 29.6446 18.3448 29.6827 17.8122 29.7462C17.6887 29.761 17.5537 29.7771 17.3861 29.8028C16.4087 29.9526 15.4864 29.9806 14.9348 29.9806Z" fill="#777777"/>
		</svg>
	}

  return (
	<div className={cn('avatar avatar-container', size)}>
		{generateAvatarImage()}
	</div>
  )
}
export default Avatar